import React from 'react'
import { Card } from '@themesberg/react-bootstrap';
import { Space, Table, Button as AntButton, Collapse, Tooltip } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRecoilState, useSetRecoilState } from 'recoil';
import { EditorState } from "draft-js";
import { EditModal } from './Modal';

import { settingAlert, settingResponse } from '../../../states/settings';
import { getRawData } from '../../../services/utilities';
import confirm from 'antd/lib/modal/confirm';
import { deleteFaq, deleteHowItWork } from '../../../services/apiCalls';
import { editFaqModal, editFaqVal, faqEditor, faqRefresh } from '../../../states/faqs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

export default ({ data }) => {
  const setShowModal = useSetRecoilState(editFaqModal);
  const setResponse = useSetRecoilState(settingResponse)
  const [value, setValue] = useRecoilState(editFaqVal)
  const setEditor = useSetRecoilState(faqEditor)
  const setRefresh = useSetRecoilState(faqRefresh)
  const setShowAlert = useSetRecoilState(settingAlert);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Content',
      dataIndex: 'content',
      key: 'content',
      render: text => <p dangerouslySetInnerHTML={{ __html: text }} />
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => (
        <Space size="middle">
          <AntButton type="ghost" onClick={() => handleCreate(record)}>Edit </AntButton>
          <AntButton type="danger" onClick={()=>confirmDelete(id)}>Delete</AntButton>
        </Space>
      ),
    },
  ];
  const handleCreate = (value) => {
    setValue(value)
    if (value.content) {
      const contentState = getRawData(value.content)
      setEditor(EditorState.createWithContent(contentState));
    }
    setShowModal(true)
    setResponse({})
  }
  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteFaq(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  console.log(data) // setCreateModal(true)  confirmDelete(id)
  const genExtra = (e) => (    
    <Space size="small">
      <Tooltip title='Edit'>
        <AntButton type="ghost" onClick={() => handleCreate(e)}> 
          <FontAwesomeIcon icon={faEdit} />
        </AntButton>
      </Tooltip>
      <Tooltip title='Delete'>
        <AntButton type="danger" onClick={() => confirmDelete(e.id)}>
          <FontAwesomeIcon icon={faTrash} />
        </AntButton>
      </Tooltip>
    </Space>
  );

  return (
    <Card border="light" className="table-wrapper table-responsive shadow-sm">
      <EditModal value={value} />
      <Collapse accordion>
        {data && 
        data.map(b=>(
          <Collapse.Panel header={b.title} key={b.id} extra={genExtra(b)}>
            <p dangerouslySetInnerHTML={{ __html: b.content }} />
          </Collapse.Panel>
        ))
        }
      </Collapse>
    </Card>
  );
};
